import { render } from "./SlidesWithText.vue?vue&type=template&id=47e80b75"
import script from "./SlidesWithText.vue?vue&type=script&lang=js"
export * from "./SlidesWithText.vue?vue&type=script&lang=js"

import "./SlidesWithText.vue?vue&type=style&index=0&id=47e80b75&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__